// Function loadTextFeature loads the TextFeature class by dynamically importing the js on demand if needed

export function loadTextFeature($parentEl, isList = false) {

	let $wg = $parentEl.querySelector('.textFeature');

	if(!$wg) {
		// console.info('TextFeature: no widget found');
		return Promise.reject('ArticleGallery widget not found in the parent element');
	}

	return import(/* webpackChunkName: "wg-text-feature-chunk" */ '../widgets/textFeature').then(wg => {

		const { TextFeature } = wg;

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('.textFeature');
			let instances = [];
			Array.from($wgCol).forEach(($wg, i) => {
				instances.push( new TextFeature($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new TextFeature($wg);
		}


	}).catch(error => error+'An error occurred while loading the TextFeature widget');

}
